/**
 * Logo list – Swiper auto-scrolling carousel (desktop + mobile)
 */
(function () {
  function initLogoListCarousels() {
    document.querySelectorAll('.logo-list[data-section-id]').forEach(function (sectionEl) {
      var swiperEl = sectionEl.querySelector('.logo-list__swiper');
      if (!swiperEl || swiperEl.dataset.swiperInit === 'true') return;

      var columns = parseInt(sectionEl.dataset.columns, 10) || 5;

      if (typeof Swiper === 'undefined') return;

      var slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      var config = {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        grabCursor: true,
        speed: 10000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        breakpoints: {
          768: {
            slidesPerView: Math.min(4, slides.length),
            spaceBetween: 40
          },
          1024: {
            slidesPerView: Math.min(columns, slides.length),
            spaceBetween: 40
          }
        }
      };

      /* eslint-disable no-new */
      new Swiper(swiperEl, config);
      swiperEl.dataset.swiperInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoListCarousels);
  } else {
    initLogoListCarousels();
  }

  document.addEventListener('shopify:section:load', function () {
    initLogoListCarousels();
  });
})();
